// extracted by mini-css-extract-plugin
export default {"body":"body-f0eo4","afterCopyAlertBody":"afterCopyAlertBody-EqZri"};